<script module lang="ts">
  import type { Styles } from '@agapi/ui/panda/css';
  export interface ComboboxInputProps {
    placeholder?: string;
    inputStyles?: Styles;
    controlStyles?: Styles;
    triggerStyles?: Styles;
  }
</script>

<script lang="ts">
  import { useComboboxContext } from '../use-combobox-context';
  import { comboboxStyles } from '../combobox.styles';
  import { CaretUp, CaretDown } from 'phosphor-svelte';
  import { css } from '@agapi/ui/panda/css';
  /**
   * Combobox input component.
   * Renders an input element connected to the combobox state machine.
   */
  const { api } = useComboboxContext();
  const classes = comboboxStyles.raw();
  const { placeholder, inputStyles, controlStyles, triggerStyles }: ComboboxInputProps = $props();
</script>

<div {...api.getControlProps()} class={css(classes.control, controlStyles)}>
  <input {...api.getInputProps()} class={css(classes.input, inputStyles)} placeholder={placeholder} onclick={() => api.setOpen(true)}/>
  <button {...api.getTriggerProps()} class={css(classes.trigger, triggerStyles)}>
    {#if api.open}
      <CaretUp size={24} />
    {:else}
      <CaretDown size={24} />
    {/if}
  </button>
</div>